import React, {useCallback} from 'react';

import {SearchPbId} from 'src/components/search-pb-id';
import {ReferenceEntityType} from 'src/openapi/admin/models/ReferenceEntityType';

import {FlatButton} from '@pb/kit-component-button';
import {Group} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';


import type {AccountDetails} from 'src/modules/create-account/typedef';

type Props = {
    pbIds: Array<string>,
    disabled?: boolean,
    onChange: React.Dispatch<React.SetStateAction<AccountDetails>>,
    onFieldChange: () => void,
};

export const PbIdsForm: React.FC<Props> = ({pbIds, onChange, disabled, onFieldChange}) => {
    const onPBIdSelect = useCallback((pbId: string, id: number) => {
        onFieldChange();
        onChange(details => ({
            ...details, pbIds: details.pbIds.map((prevPbId, i) => (
                i === id ? pbId : prevPbId
            )),
        }));
    }, [onChange, onFieldChange]);

    const onAddPBIDFormItem = useCallback(() => {
        onChange(details => ({...details, pbIds: [...details.pbIds, '']}));
    }, [onChange]);

    const onRemovePBIDFormItem = useCallback((id: number) => {
        onChange(details => ({
            ...details, pbIds: details.pbIds.filter((pbId, i) => i !== id),
        }));
    }, [onChange]);

    return (
        <Group direction="v" gap="s" alignItems="start">
            {pbIds.map((pbId, id) => (
                <SearchPbId
                    width={300}
                    key={pbId}
                    id={id}
                    value={pbId}
                    onSelect={onPBIdSelect}
                    onRemove={onRemovePBIDFormItem}
                    pbIds={pbIds}
                    disabled={disabled}
                    entityType={ReferenceEntityType.COMPANY_TYPE}
                />
            ))}
            <FlatButton
                disabled={disabled || pbIds.includes('') || pbIds.length >= 10}
                startIcon={<Icon type={Icons.PLUS_CIRCLE}/>}
                onClick={onAddPBIDFormItem}>
                <b>Add PB RTS ID</b>
            </FlatButton>
        </Group>
    );
};
